import { CreateFormKeys } from '@features/feedback/create-feedback-request/config/form-constants';
import { CreateFormFields } from '@features/feedback/create-feedback-request/ui/modal-create-feedback/types';
import createDecorator from 'final-form-calculate';
import { Decorator } from 'final-form';
import { FeedbackMigrateCodes } from '@shared/model/feedback';

export const feedbackSubjectDecorator = createDecorator({
    field: CreateFormKeys.Subject,
    updates: {
        [CreateFormKeys.Product]: (_, allValues) => {
            const subject = allValues?.[CreateFormKeys.Subject]?.[0];
            if (subject?.value !== FeedbackMigrateCodes.Products) {
                return;
            }
        },
        [CreateFormKeys.Order]: (_, allValues) => {
            const subject = allValues?.[CreateFormKeys.Subject]?.[0];
            if (subject?.value !== FeedbackMigrateCodes.Orders) {
                return;
            }
        },
    },
}) as Decorator<CreateFormFields, Partial<CreateFormFields>>;
